import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { WHAT_WE_MAKE } from "../data/siteContent";
import Seo from "../components/Seo";

export default function WhatWeMake() {
  return (
    <div className="min-h-screen" data-testid="what-we-make-page">
      <Seo
        title="What We Make"
        description="Custom basswood signs, layered wall decor, personalized gifts, mason jar toppers, business logo signs, and seasonal pieces from Beyond Board Woodworking."
        path="/what-we-make"
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-12">
        <p className="text-xs uppercase tracking-[0.28em] text-[#D8A34B] mb-3">What We Make</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F0E6] leading-tight">Custom basswood signs, decor, gifts, and layered pieces for meaningful spaces</h1>
        <p className="mt-6 text-[#B8B7B2] max-w-3xl text-lg leading-relaxed">
          We primarily create our layered signs and decor from laser-cut basswood,
          then finish each piece with paint, stain, and detail work. From door hangers
          to memorial pieces and logo signs, every order starts with your idea and ends
          with a handcrafted piece built to fit your style.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-testid="what-we-make-grid">
        {WHAT_WE_MAKE.map((item, index) => (
          <article
            key={item.id}
            className="rounded-2xl border border-[#F5F0E6]/10 bg-zinc-900/60 p-7 hover:border-[#D8A34B]/40 hover:shadow-[0_8px_30px_rgba(216,163,75,0.12)] transition fade-up"
            style={{ animationDelay: `${index * 50}ms` }}
            data-testid={`make-card-${item.id}`}
          >
            <p className="text-xs uppercase tracking-[0.2em] text-[#D8A34B] mb-3">Custom Piece</p>
            <h2 className="font-display text-2xl text-[#F5F0E6]">{item.title}</h2>
            <p className="mt-4 text-[#B8B7B2] leading-relaxed">{item.description}</p>
            <Link to="/quote" state={{ inspiration: item.title, category: item.title }}>
              <Button variant="outline" className="mt-6 bg-transparent border-[#D8A34B]/60 text-[#D8A34B] hover:bg-[#D8A34B]/10 hover:text-[#F5F0E6]">
                Request a Custom Quote <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </article>
        ))}
      </section>
    </div>
  );
}